import useReveal from "../lib/useReveal";
import { Stethoscope, Salad, Dumbbell, HeartPulse } from "lucide-react";

const APPROACH_IMG =
  "https://customer-assets.emergentagent.com/job_vitality-plan/artifacts/xc2a0yzj_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2001_01_55%20PM.png";

const disciplines = [
  {
    icon: Stethoscope,
    title: "Doctors",
    body: "Diagnostic-led plans grounded in clinical evidence and your blood panel.",
  },
  {
    icon: Salad,
    title: "Nutritionists",
    body: "Cuisine-aware diet plans built around your kitchen, not a generic chart.",
  },
  {
    icon: Dumbbell,
    title: "Trainers",
    body: "Certified coaches who progress your strength with measurable weekly goals.",
  },
  {
    icon: HeartPulse,
    title: "Physiotherapists",
    body: "Pain-free movement, injury recovery, posture and joint resilience.",
  },
];

export const Approach = () => {
  const ref = useReveal();
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="relative py-16 sm:py-24 lg:py-36"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 sm:gap-12 items-start" ref={ref}>
          <div className="reveal lg:col-span-5 lg:sticky lg:top-28">
            <span className="uppercase text-[10px] sm:text-xs tracking-[0.28em] text-[#C25E3E] font-semibold">
              Our Approach
            </span>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-5 sm:mt-6 leading-[1.05] text-[#1E3A2B]">
              One body.
              <br />
              <span className="italic">Four sciences.</span>
              <br />
              One plan.
            </h2>
            <p className="mt-6 sm:mt-8 text-base sm:text-lg text-[#1E3A2B]/75 leading-relaxed max-w-md">
              Real metabolic change happens when medicine, food, movement and
              recovery speak to each other. Every Aasa plan is built by all
              four — together, in the same room.
            </p>

            <div className="mt-10 rounded-2xl overflow-hidden border border-[#D5CEBA] bg-[#FCFBF7]">
              <img
                src={APPROACH_IMG}
                alt="Aasa multidisciplinary team"
                className="w-full h-auto object-contain"
                loading="lazy"
              />
            </div>
          </div>

          <div className="reveal lg:col-span-7 lg:pl-8">
            <ul className="divide-y divide-[#D5CEBA]">
              {disciplines.map(({ icon: Icon, title, body }) => (
                <li
                  key={title}
                  data-testid={`approach-${title.toLowerCase()}`}
                  className="grid grid-cols-12 gap-6 py-8 group"
                >
                  <div className="col-span-2 flex items-start">
                    <span className="inline-flex w-12 h-12 rounded-full bg-[#EAE6DA] items-center justify-center group-hover:bg-[#C25E3E] group-hover:text-[#FCFBF7] transition-colors text-[#1E3A2B]">
                      <Icon className="w-5 h-5" />
                    </span>
                  </div>
                  <div className="col-span-10">
                    <h3 className="font-display text-2xl sm:text-3xl lg:text-4xl text-[#1E3A2B]">
                      {title}
                    </h3>
                    <p className="mt-2 sm:mt-3 text-sm sm:text-base text-[#1E3A2B]/75 max-w-xl">{body}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Approach;
